// extracted by mini-css-extract-plugin
module.exports = {"Time":"Time-module--Time--E0dLP"};